<template>
  <div class="container">
    <el-row class="clearfix" v-loading="loading" element-loading-text="拼命加载中"
            element-loading-background="rgba(0, 0, 0, 0.6)">
      <div class="floatl top-left">
        <div class="avatar" :style="avatarImg(salepersionData.headImg)" @click="showImage(salepersionData.headImg)"><img
            class="img" :src="salepersionData.headImg || ''" alt="" @error="setErrorImage" style="display: none"></div>
        <!-- <el-rate class="star-rate" v-model="starValue" disabled :colors="['#8299dc','#8299dc','#8299dc']" :disabled-void-color="'#ccc'"></el-rate>
        <div class="star-level">星级：{{salepersionData.starName}}</div> -->
        <div class="star-level">星级：{{salepersionData.starName}}</div>
        <div class="progress">
          {{starName}}
          <div class="progress-line">
            <div class="bar" :style="'width: '+precent+'%;'"></div>
            <!-- 120 -->
          </div>
          {{nextstartName}}
        </div>
        <div class="credit-num clearfix">
          <span class="floatl">{{salepersionData.creditScore}}</span>
          信用
        </div>
        <div class="credit-num clearfix">
          <span class="floatl">{{salepersionData.score}}</span>
          积分
        </div>
      </div>
      <div class="floatl top-right">
        <div class="name clearfix">
          <span class="floatl">{{salepersionData.name}}</span>
          <p class="floatr">
            <span v-if="isAdmin && salepersionData.height">{{salepersionData.age}}岁 | {{salepersionData.height}}cm</span>
            <span v-if="isAdmin && !salepersionData.height">{{salepersionData.age}}岁</span>
            <span v-if="!isAdmin && salepersionData.height">{{salepersionData.height}}cm</span>
            <span>{{sex}}</span>
            <!-- <span>{{salepersionData.birthday}}</span> -->
            <span>{{agreement}}</span>
          </p>
          <div style="clear: both;line-height: 0px;margin-bottom: 20px;">促销员ID:{{salepersionData.empPk}}</div>
        </div>
        <div class="text-info clearfix">
          <div class="floatl text-info-left">
            <p class="floatl">微信昵称：{{salepersionData.wxName || '无'}}</p>
            <p class="floatl">联系电话：{{ salepersionData.tel || '无'}}</p>
            <p class="floatl">紧急联系人：{{salepersionData.emergencyContact || '无'}}</p>
            <p class="floatl">紧急联系人电话：{{salepersionData.emergencyTel || '无'}}</p>
          </div>
          <div class="floatr text-info-right">
            <p class="floatl">推荐人：{{salepersionData.recommenderName || '无'}}</p>
            <p class="floatl">推荐人电话：{{salepersionData.recommendertel || '无'}}</p>
            <p class="floatl" :title="
              ((salepersionData.province || '') +
              (salepersionData.city || '') +
              (salepersionData.area || '') +
              (salepersionData.homeAddress || '') || '无')
            ">现住地址：{{
              ((salepersionData.province || '') +
              (salepersionData.city || '') +
              (salepersionData.area || '') +
              (salepersionData.homeAddress || '') || '无')}}
            </p>
            <p class="floatl">户口地址：{{salepersionData.registeredAdd || '无'}}</p>
          </div>
        </div>
        <div class="latest-proj clearfix" style="padding: 5px!important;">
          <div class="proj-box floatl">
            <p class="p1">{{salepersionData.insertTime}}</p>
            <p class="p2">注册时间</p>
          </div>
          <div class="proj-box floatl">
            <p class="p1" :title="salepersionData.lastPrj">{{salepersionData.lastPrj}}</p>
            <p class="p2">最近一次项目</p>
          </div>
          <div class="proj-box floatl">
            <p class="p1">{{salepersionData.lastPrjTime}}</p>
            <p class="p2">最近一次项目时间</p>
          </div>
        </div>
        <div class="latest-proj clearfix" style="margin-top: 0px!important;padding: 5px!important;">
          <div class="proj-box floatl">
            <p class="p1">{{salepersionData.identityAuthenticationTime}}</p>
            <p class="p2">身份认证时间</p>
          </div>
          <div class="proj-box floatl">
            <p class="p1">{{salepersionData.realNameAuthenticationTime}}</p>
            <p class="p2">实名认证时间</p>
          </div>
        </div>
        <div class="tags-wrap clearfix">
          <div class="tag clearfix">
            <h2>标签</h2>
            <div class="tag-body">
              <el-tag class="tag-item" type="info" v-for="(item, index) in salepersionData.signName" :key="index">
                {{item}}
              </el-tag>
            </div>
          </div>
          <div class= "line"></div>
          <div class="tag" style="margin-left: 0px;padding: 5px;">
            <h2>自我喜好</h2>
            <div class="tag-body">
              <el-tag class="tag-item" type="info" v-for="(item, index) in salepersionData.selfSignName" :key="index">
                {{item}}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <el-row class="cards">
      <div class="card-img clearfix" style="display:flex;justify-content:space-between ">
        <div class="imgs" :style="noCompression(salepersionData.idcardCover)">
          <img
              :src="salepersionData.idcardCover ? salepersionData.idcardCover :'https://120.55.166.247:9191/noimg/no/no/no.jpg'"
              style="display: none" @error="imgError1">
        </div>
        <div class="imgs"
             :style="noCompression((!salepersionData.idcardBack || salepersionData.idcardBack.slice(-4) == 'null') ? idcardDefaultBack : salepersionData.idcardBack)">
          <!-- <img :src="(!salepersionData.idcardBack || salepersionData.idcardBack.slice(-4) == 'null') ? idcardDefaultBack : salepersionData.idcardBack" class="floatl" alt="身份证正面"> -->
        </div>
        <div class="imgs" :style="noCompression(salepersionData.bankCover)">
          <img
              :src="salepersionData.bankCover ? salepersionData.bankCover :'https://120.55.166.247:9191/noimg/no/no/no.jpg'"
              style="display: none" @error="imgError2">
          <!-- <img :src="(!salepersionData.bankCover || salepersionData.bankCover.slice(-4) == 'null') ? bankcardDefaultCover : salepersionData.bankCover" class="floatl" alt="银行卡"> -->
        </div>

      </div>
      <div class="card-info clearfix">
        <div class="idCard floatl">
          身份证号：{{salepersionData.idcard}}
        </div>
        <div class="bankCard floatr">
          <p>开户行：{{salepersionData.bank}}</p>
          <p>银行卡号：{{salepersionData.bankNum}}</p>
        </div>
      </div>
    </el-row>
    <div class="viewImage">
      <el-dialog
          title="查看大图"
          :visible.sync="showbigImage"
          v-model="bigImage"
          :width="bigImageWidth2"
          class="dialog"
          :modal="false"
      >
        <div class="dialogImage" :style="avatarBigImg(bigImage)">
          <img :src="bigImage || ''" alt="" @error="setErrorImage">
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="showbigImage = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  //这是基础中心和任务中心的组件。。跨菜单的共通组件都放这里
  import avatarDefault from 'common/images/avatar-default.png'
  import idcardDefaultCover from 'common/images/idCard-img.png'
  import idcardDefaultBack from 'common/images/idCard-img2.png'
  import bankcardDefaultCover from 'common/images/bankCard-img.png'
  import utils from '../common/js/util.js'

  export default {
    data() {
      return {
        isAdmin:false,//是否是tinashi或者admin1

        salepersionData: '',
        starValue: null,
        sex: '',
        agreement: '',

        avatarDefault: avatarDefault,
        idcardDefaultCover: idcardDefaultCover,
        idcardDefaultBack: idcardDefaultBack,
        bankcardDefaultCover: bankcardDefaultCover,
        bigImage: null,
        bigImageWidth: null,
        bigImageHeight: null,
        bigImageWidth2: null,
        showbigImage: false,

        loading: false,

        starName: null,
        nextstartName: null,
        precent: null
      };
    },
    props: ['id', "auths"],
    mounted() {
      let x = sessionStorage.getItem('user')
      this.isAdmin =  Boolean(x == 'admin1' || x == 'tinashi');

      this.loading = true
      this.$http({
        method: "POST",
        url: '/rest/SalesmanParticulars/basicInformation',
        params: {
          id: this.id
        }
      }).then(res => {
        let data = res.data
        if (!this.isAdmin) {
          data.tel = utils.plusXing(data.tel, 3, 4)
          data.idcard = utils.plusXing(data.idcard, 6, 4)
          data.bankNum = utils.plusXing(data.bankNum, 4, 7)
        }
        data.emergencyTel = utils.plusXing(data.emergencyTel, 3, 4);
        data.recommendertel = utils.plusXing(data.recommendertel, 3, 4)
        this.salepersionData = data
        this.starValue = data.starScore / 10000 * 5
        switch (data.sex) {
          case 1:
            this.sex = '男';
            break;
          case 2:
            this.sex = '女';
            break;
          default:
            this.sex = '性别未知'
        }
        (data.agreement === 1) ? this.agreement = '有合约' : this.agreement = '无合约'

        this.loading = false
        this.$http({
          method: "GET",
          url: "/rest/SearchScoreDetails/searchNextStartName",
          params: {
            score: this.salepersionData.starScore
          }
        }).then(res => {
          let data1 = res.data
          this.starName = data1.startName
          this.nextstartName = data1.nextstartName
          this.precent = (data1.mindifferenceScore / data1.poorScore) * 100
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      }).catch(err => {
        utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        this.loading = false
      })
    },
    methods: {
      // 图片出错
      setErrorImage(event) {
        event.target.parentNode.style.backgroundImage = `url(${this.avatarDefault})`
      },
      imgError1(event) {
        // setTimeout((event)=>{
        event.target.parentNode.style.backgroundImage = `url(${idcardDefaultCover})`
        event.target.parentNode.style.backgroundSize = 'cover'
        // },100,event)
      },
      imgError2(event) {
        // setTimeout((event)=>{
        event.target.parentNode.style.backgroundImage = `url(${bankcardDefaultCover})`
        event.target.parentNode.style.backgroundSize = 'cover'
        // },100,event)
      },
      avatarImg(url) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover',
            width: '150px',
            height: '150px',
          }
        } else {
          return {
            backgroundImage: 'url(' + this.avatarDefault + ')',
            backgroundSize: 'cover',
            width: '150px',
            height: '150px',
          }
        }

      },
      avatarBigImg(url) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover',
            width: this.bigImageWidth,
            height: this.bigImageHeight
          }
        } else {
          return {
            backgroundImage: 'url(' + this.avatarDefault + ')',
            backgroundSize: 'cover',
            width: this.bigImageWidth,
            height: this.bigImageHeight
          }
        }

      },
      showImage(url) {
        this.showbigImage = true;
        this.bigImage = url
      },
      noCompression(url) {
        //img的err事件有小概率在此之前执行，同样设置backgroundImage
        //为防止被此覆盖加个if判断，刚进来的时候不执行此语句
        if (url) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover',
          }
        }
      },
    },
    updated() {
      let width = document.getElementsByClassName('img')[0].width
      let height = document.getElementsByClassName('img')[0].height
      width > 500 ? (width = width / 2 , height = height / 2) : (width, height)
      width < 300 ? (width = 300 , height = 300) : (width, height)
      this.bigImageWidth = width + 'px';
      this.bigImageWidth2 = width + 40 + 'px';
      this.bigImageHeight = height + 'px';
    }
  };
</script>

<style lang="scss" scoped>
  @import "../common/styles/variable.scss";
  // 查看大图
  .dialog {
    .dialogImage {
      // padding: 20px;
      img {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }

  .imgs {
    width: 300px;
    height: 190px;
  }

  .container {
    width: 990px;
    height: 480px;
    overflow-y: auto;
    overflow-x: hidden;

  }

  .top-left {
    width: 240px;
    height: 470px;
    border-radius: 5px;
    background-color: #f4f4f4;
    box-sizing: border-box;
    padding: 0 10px;
    .avatar {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      margin: 20px auto 0;
      img {
        border-radius: 50%;
        opacity: 0;
      }
    }
    .star-level {
      height: 60px;
      color: #333;
      line-height: 60px;
      font-size: 14px;
      text-align: center;
      margin-top: 17px;
    }
    .progress {
      width: 100%;
      height: 12px;
      line-height: 12px;
      text-align: center;
      font-size: 12px;
      color: #999;
      .progress-line {
        width: 140px;
        height: 12px;
        display: inline-block;
        background: #e2e2e2;
        border-radius: 6px;
        margin: 0 5px;
        color: #fb642d;
        text-align: left;
        line-height: 12px;
        .bar {
          height: 12px;
          border-radius: 6px;
          display: inline-block;
          background: linear-gradient(to right, #f8b332, #f79355);
        }
      }
    }
    .credit-num {
      line-height: 72px;
      border-top: 1px solid #e2e2e2;
      margin-top: 20px;
      font-size: 14px;
      color: #333;
      text-align: right;
      padding: 0 10px;
      span {
        color: #f78e4a;
        font-size: 38px;
        font-weight: bold;
      }
    }
    .chart {
      border-top: 1px solid #e2e2e2;
      padding: 0 10px;
      .point {
        line-height: 60px;
      }
      .text {
        color: #333;
      }
      .num {
        color: #999;
        span {
          font-size: 18px;
          color: #f78f4e;
        }
      }
      .progress-line {
        width: 200px;
        height: 12px;
        display: inline-block;
        background: #e2e2e2;
        border-radius: 6px;
        margin: 0 auto;
        line-height: 12px;
        .bar {
          height: 12px;
          border-radius: 6px;
          display: inline-block;
          background: linear-gradient(to right, #b7c5f6, #849cda);
        }
      }
    }
  }

  .top-right {
    width: 710px;
    min-height: 470px;
    border-radius: 5px;
    background-color: #f4f4f4;
    box-sizing: border-box;
    padding: 0 20px;
    margin-left: 10px;
    .name {
      line-height: 60px;
      span.floatl {
        font-size: 18px;
        font-weight: bold;
        color: $theme-font-color;
      }
      p.floatr {
        color: $theme-light-color;
        font-size: 14px;
        span {
          margin-left: 30px;
        }
      }
    }
    .text-info {
      width: 100%;
      p {
        font-size: 14px;
        color: #999;
        line-height: 33px;
        width: 100%;
      }
      .text-info-left {
        width: 340px;
      }
      .text-info-right {
        width: 330px;
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .latest-proj {
      height: 60px;
      padding: 10px;
      background-color: #fff;
      margin-top: 15px;
      .proj-box {
        width: 215px;
        height: 60px;
        border-left: 1px solid #f4f4f4;
        text-align: center;
        &:first-child {
          border-left: none;
        }
        p.p1 {
          width: 100%;
          height: 36px;
          padding: 0 10px;
          margin: 0 auto;
          box-sizing: border-box;
          line-height: 36px;
          color: $color-green;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p.p2 {
          line-height: 1em;
          color: #b5b5b5;
        }
      }
    }
    .tags-wrap {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
    }
    .tag {
      flex: 1;
      border-right: 1px solid #e2e2e2;
      min-height: 80px;
      &:last-of-type{
        border-right: none;
      }
      h2 {
        line-height: 20px;
        font-weight: bold;
        font-size: 14px;
        color: #333;
      }
      .tag-body {
        overflow-y: auto;
        overflow-x: hidden;
        .tag-item {
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .left{
   float: left;
   border-left: 1px solid #e2e2e2;
   height: 83px;
   margin-top: -155px;
   margin-left: 284px;
  }

  .cards {
    width: 960px;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 20px 20px 0;
    background-color: #f4f4f4;
    border-radius: 5px;
    .card-img {
      width: 100%;
      height: 190px;
      img {
        width: 300px;
        height: 190px;
        margin-left: 10px;
        &:first-child {
          margin-left: 0
        }
      }
    }
    .card-info {
      color: #666;
      width: 100%;
      .idCard {
        width: 600px;
        margin-top: 5px;
        line-height: 18px;
        font-size: 12px;
      }
      .bankCard {
        width: 300px;
        margin-top: 5px;
        line-height: 24px;
        font-size: 12px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/salespersonInfo.vue